/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react';
import { getProxyUrl } from '../../utils/image';
import moment from "moment/moment";
import { textExcerpt } from "../../utils/functionalUtils";

function TeamNewsCard({ article, idx }) {
  const { title, image, dateTime, description, articleUrl } = article;
  const articleImage = getProxyUrl(image);

  return (
    <>
      {idx === 0 ? (
        <div className="col-12 mb-4">
          <a
              href={articleUrl}
              title={title}
              target="_blank"
              rel="noreferrer"
              className="article-featured"
          >
            <img
                src={articleImage} alt=""
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null;
                  currentTarget.src = "/wp-content/themes/sef-leagues/images/fallback-image-allsvenskan.png";
                }}
            />
            <div className="article-featured__info">
              <time
                className="text-small text-color-primary-yellow text-uppercase fw-bold mb-1"
                dateTime={dateTime}
              >
                {moment(dateTime).format('DD MMMM').toUpperCase()}
              </time>
              <h2 className="heading-h5 heading-sm-h5 text-transform-none mb-2">
                {title}
              </h2>
              <p className="text-small text-sm-regular fw-bold">
                {textExcerpt(description)}
              </p>
            </div>
          </a>
        </div>
      ) : (
        <div className="col-12 col-md-6 col-lg-4 mb-4 d-flex">
          <a
              href={articleUrl}
              title={title}
              target="_blank"
              rel="noreferrer"
              className="article-vertical"
          >
            <img
                src={articleImage} alt=""
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null;
                  currentTarget.src = "/wp-content/themes/sef-leagues/images/fallback-image-allsvenskan.png";
                }}
            />
            <div className="article-vertical__info">
              <time
                className="text-small text-color-primary-yellow text-uppercase fw-bold mb-1"
                dateTime={dateTime}
              >
                {moment(dateTime).format('DD MMMM').toUpperCase()}
              </time>
              <h2 className="heading-h5 heading-sm-h5 text-transform-none mb-2">
                {title}
              </h2>
              <p className="text-small text-sm-regular fw-bold">
                {textExcerpt(description)}
              </p>
            </div>
          </a>
        </div>
      )}
    </>
  );
}

export default TeamNewsCard;
